<template>
  <div :class="{disabled}" style="position: relative;">
    <div class="border-overlay" :class="{selected}" @click="disabled ? () => {} : clickMethod(value)"></div>
    <div class="card fragrance-profile-card">
      <div class="card-body" :style="{ backgroundImage: `url(${background})`}">
        <div class="description-container">
          <span>{{ header }}</span>
          <div class="info-icon" v-b-tooltip.hover.html="tooltips[tooltip]">
            <font-awesome-icon icon="info-circle"/>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'FragranceFormCard',
  props: {
    header: String,
    value: String,
    tooltip: String,
    selected: Boolean,
    disabled: Boolean,
    clickMethod: Function,
    background: {
      type: String,
      required: false
    }
  },
  data () {
    return {
      tooltips: {
        olfactives: 'Consumer perception of olfactive characterstics such as florals, fruity, woody etc.',
        descriptives: 'Consumer perception of words that are used to describe the fragrance like fresh, clean, caring etc.',
        moods: 'Dive in to explore the wide variety of  moods that are associated with fragrances tested.',
        usage: 'Explore and understand what fragrances are associated with usage such as for someone like me,special occasion etc.'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../assets/scss/variables.scss";

.border-overlay {
  cursor: pointer;
  @media screen and (min-width: 0px) {
    width: 176px;
    height: 137px;
  }
  @media screen and (min-width: $break-xl) {
    width: 216px;
    height: 168px;
  }
  @media screen and (min-width: $break-xxl) {
    width: 256px;
    height: 199px;
  }
  border-radius: 10px;
  position: absolute;
  z-index: 2;
  margin: 0 5px;

  &:hover {
    border: 5px solid $fragrance-profile;
  }

  &.selected {
    border: 5px solid $fragrance-profile;
  }
}

.fragrance-profile-card {
  cursor: pointer;
  @media screen and (min-width: 0px) {
    width: 176px;
    height: 137px;
  }
  @media screen and (min-width: $break-xl) {
    width: 216px;
    height: 168px;
  }
  @media screen and (min-width: $break-xxl) {
    width: 256px;
    height: 199px;
  }
  margin: 0 5px;
  border-color: #E7B06A;
  border-radius: 10px;
  box-shadow: 0 3px 6px #000000CC;

  .card-body {
    padding: 0;
    color: $home-card;
    width: 100%;
    height: 100%;
    background-position: center;
    background-size: cover;
    display: flex;
    align-items: flex-end;
    border-radius: 10px;

    .description-container {
      width: 100%;
      height: 96px;
      background-color: rgba(240, 241, 247, 0.6);
      border-bottom-left-radius: 10px;
      border-bottom-right-radius: 10px;
      display: flex;
      justify-content: center;
      align-items: center;
      position: relative;

      .info-icon {
        line-height: 24px;
        color: #76706B;
        position: absolute;
        font-size: 24px;
        bottom: 5px;
        right: 5px;
        z-index: 3;
      }

      span {
        font-family: 'Open Sans', sans-serif;
        font-weight: 800;
        font-size: 24px;
        line-height: 26px;
        letter-spacing: 0;
        text-align: center;
        color: $fragrance-profile;
      }
    }
  }
}

.card a[disabled] {
  background-color: darkgray;
  pointer-events: none;
  cursor: default;
}

.disabled {
  .border-overlay {
    cursor: default;
    &:hover {
      border: unset !important;
    }
  }
  .fragrance-profile-card {
    cursor: pointer;
    @media screen and (min-width: 0px) {
      width: 176px;
      height: 137px;
    }
    @media screen and (min-width: $break-xl) {
      width: 216px;
      height: 168px;
    }
    @media screen and (min-width: $break-xxl) {
      width: 256px;
      height: 199px;
    }
    margin: 0 5px;
    border-color: $pewter;
    border-radius: 10px;
    box-shadow: 0 3px 6px #000000CC;
    .card-body {
      padding: 0;
      color: $home-card;
      width: 100%;
      height: 100%;
      background-position: center;
      background-size: cover;
      display: flex;
      align-items: flex-end;
      border-radius: 10px;
      filter: grayscale(0.5);
      .description-container {
        width: 100%;
        height: 96px;
        background-color: rgba(240, 241, 247, 0.6);
        border-bottom-left-radius: 10px;
        border-bottom-right-radius: 10px;
        display: flex;
        justify-content: center;
        align-items: center;
        position: relative;
        .info-icon {
          line-height: 24px;
          color: #76706B;
          position: absolute;
          font-size: 24px;
          bottom: 5px;
          right: 5px;
          z-index: 3;
        }
        span {
          font-family: 'Open Sans', sans-serif;
          font-weight: 800;
          font-size: 24px;
          line-height: 26px;
          letter-spacing: 0;
          text-align: center;
          color: $pewter !important;
        }
      }
    }
  }
}
</style>
